import React, { useState } from 'react';
import {  Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import PhoneList from './ContactData/PhoneList';
import EmailList from './ContactData/EmailList';
import AddressList from './ContactData/AddressList';
import SocialList from './ContactData/SocialList';

const DatoTab = () => {
  const [activeTab, setActiveTab] = useState('1');

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  }

  const tabs = [
    { id: '1', icon: 'bx bx-mobile', label: 'Teléfonos', component: <PhoneList /> },
    { id: '2', icon: 'fas fa-envelope', label: 'Emails', component: <EmailList /> },
    { id: '3', icon: 'bx bx-map', label: 'Direcciones', component: <AddressList /> },
    { id: '4', icon: 'bx bx-share-alt', label: 'Redes Sociales', component: <SocialList /> }
  ];

  return (
    <div className="contact-data-tabs">
      <Nav tabs className="data-tabs-nav">
        {tabs.map(tab => (
          <NavItem key={tab.id}>
            <NavLink
              className={classnames({ active: activeTab === tab.id })}
              onClick={() => toggle(tab.id)}
            >
              <i className={`${tab.icon} me-2`}></i>
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <TabContent activeTab={activeTab} className="p-3">
        {tabs.map(tab => (
          <TabPane key={tab.id} tabId={tab.id}>
            {tab.component}
          </TabPane>
        ))}
      </TabContent>
    </div>
  );
}

export default DatoTab;